// @ts-nocheck
// set multiple fields...
export const SET_CONTRACTOR_MULTIPLE_FIELDS = "SET_CONTRACTOR_MULTIPLE_FIELDS";

// get all contractors
export const FETCH_CONTRACTORS_REQUEST = "FETCH_CONTRACTORS_REQUEST";
export const FETCH_CONTRACTORS_SUCCESS = "FETCH_CONTRACTORS_SUCCESS";
export const FETCH_CONTRACTORS_FAILURE = "FETCH_CONTRACTORS_FAILURE";

// toggle contractor status
export const TOGGLE_CONTRACTOR_STATUS_REQUEST =
  "TOGGLE_CONTRACTOR_STATUS_REQUEST";
export const TOGGLE_CONTRACTOR_STATUS_SUCCESS =
  "TOGGLE_CONTRACTOR_STATUS_SUCCESS";
export const TOGGLE_CONTRACTOR_STATUS_FAILURE =
  "TOGGLE_CONTRACTOR_STATUS_FAILURE";

// delete contractor
export const DELETE_CONTRACTOR_REQUEST = "DELETE_CONTRACTOR_REQUEST";
export const DELETE_CONTRACTOR_SUCCESS = "DELETE_CONTRACTOR_SUCCESS";
export const DELETE_CONTRACTOR_FAILURE = "DELETE_CONTRACTOR_FAILURE";

// add contractor
export const CREATE_CONTRACTOR_REQUEST = "CREATE_CONTRACTOR_REQUEST";
export const CREATE_CONTRACTOR_SUCCESS = "CREATE_CONTRACTOR_SUCCESS";
export const CREATE_CONTRACTOR_FAILURE = "CREATE_CONTRACTOR_FAILURE";

// update contractor info
export const UPDATE_CONTRACTOR_REQUEST = "UPDATE_CONTRACTOR_REQUEST";
export const UPDATE_CONTRACTOR_SUCCESS = "UPDATE_CONTRACTOR_SUCCESS";
export const UPDATE_CONTRACTOR_FAILURE = "UPDATE_CONTRACTOR_FAILURE";

// upload contractor image
export const UPLOAD_CONTRACTOR_IMAGE_REQUEST =
  "UPLOAD_CONTRACTOR_IMAGE_REQUEST";
export const UPLOAD_CONTRACTOR_IMAGE_SUCCESS =
  "UPLOAD_CONTRACTOR_IMAGE_SUCCESS";
export const UPLOAD_CONTRACTOR_IMAGE_FAILURE =
  "UPLOAD_CONTRACTOR_IMAGE_FAILURE";

// add preferred position
export const ADD_PREFERRED_POSITION_REQUEST = "ADD_PREFERRED_POSITION_REQUEST";
export const ADD_PREFERRED_POSITION_SUCCESS = "ADD_PREFERRED_POSITION_SUCCESS";
export const ADD_PREFERRED_POSITION_FAILURE = "ADD_PREFERRED_POSITION_FAILURE";

// remove preferred position
export const REMOVE_PREFERRED_POSITION_REQUEST =
  "REMOVE_PREFERRED_POSITION_REQUEST";
export const REMOVE_PREFERRED_POSITION_SUCCESS =
  "REMOVE_PREFERRED_POSITION_SUCCESS";
export const REMOVE_PREFERRED_POSITION_FAILURE =
  "REMOVE_PREFERRED_POSITION_FAILURE";

// Approve contractor
export const APPROVE_CONTRACTOR_REQUEST = "APPROVE_CONTRACTOR_REQUEST";
export const APPROVE_CONTRACTOR_SUCCESS = "APPROVE_CONTRACTOR_SUCCESS";
export const APPROVE_CONTRACTOR_FAILURE = "APPROVE_CONTRACTOR_FAILURE";

// Gusto Approve contractor
export const GUSTO_APPROVE_CONTRACTOR_REQUEST =
  "GUSTO_APPROVE_CONTRACTOR_REQUEST";
export const GUSTO_APPROVE_CONTRACTOR_SUCCESS =
  "GUSTO_APPROVE_CONTRACTOR_SUCCESS";
export const GUSTO_APPROVE_CONTRACTOR_FAILURE =
  "GUSTO_APPROVE_CONTRACTOR_FAILURE";

// Add contractor step1
export const ADD_CONTRACTOR_STEP1_REQUEST = "ADD_CONTRACTOR_STEP1_REQUEST";
export const ADD_CONTRACTOR_STEP1_SUCCESS = "ADD_CONTRACTOR_STEP1_SUCCESS";
export const ADD_CONTRACTOR_STEP1_FAILURE = "ADD_CONTRACTOR_STEP1_FAILURE";

// Add contractor step1 update
export const ADD_CONTRACTOR_STEP1_UPDATE_REQUEST =
  "ADD_CONTRACTOR_STEP1_UPDATE_REQUEST";
export const ADD_CONTRACTOR_STEP1_UPDATE_SUCCESS =
  "ADD_CONTRACTOR_STEP1_UPDATE_SUCCESS";
export const ADD_CONTRACTOR_STEP1_UPDATE_FAILURE =
  "ADD_CONTRACTOR_STEP1_UPDATE_FAILURE";

// Add contractor step2
export const ADD_CONTRACTOR_STEP2_REQUEST = "ADD_CONTRACTOR_STEP2_REQUEST";
export const ADD_CONTRACTOR_STEP2_SUCCESS = "ADD_CONTRACTOR_STEP2_SUCCESS";
export const ADD_CONTRACTOR_STEP2_FAILURE = "ADD_CONTRACTOR_STEP2_FAILURE";

// Add contractor step3
export const ADD_CONTRACTOR_STEP3_REQUEST = "ADD_CONTRACTOR_STEP3_REQUEST";
export const ADD_CONTRACTOR_STEP3_SUCCESS = "ADD_CONTRACTOR_STEP3_SUCCESS";
export const ADD_CONTRACTOR_STEP3_FAILURE = "ADD_CONTRACTOR_STEP3_FAILURE";

// Add contractor step4
export const ADD_CONTRACTOR_STEP4_REQUEST = "ADD_CONTRACTOR_STEP4_REQUEST";
export const ADD_CONTRACTOR_STEP4_SUCCESS = "ADD_CONTRACTOR_STEP4_SUCCESS";
export const ADD_CONTRACTOR_STEP4_FAILURE = "ADD_CONTRACTOR_STEP4_FAILURE";

// Add contractor step5
export const ADD_CONTRACTOR_STEP5_REQUEST = "ADD_CONTRACTOR_STEP5_REQUEST";
export const ADD_CONTRACTOR_STEP5_SUCCESS = "ADD_CONTRACTOR_STEP5_SUCCESS";
export const ADD_CONTRACTOR_STEP5_FAILURE = "ADD_CONTRACTOR_STEP5_FAILURE";
export const UPDATE_CONTRACTOR_CERTIFICATES_STEP5 =
  "UPDATE_CONTRACTOR_CERTIFICATES_STEP5";

// fetch contractor data...
export const FETCH_CONTRACTOR_REQUEST = "FETCH_CONTRACTOR_REQUEST";
export const FETCH_CONTRACTOR_SUCCESS = "FETCH_CONTRACTOR_SUCCESS";
export const FETCH_CONTRACTOR_FAILURE = "FETCH_CONTRACTOR_FAILURE";

// Setup edit contractor
export const SETUP_EDIT_CONTRACTOR_REQUEST = "SETUP_EDIT_CONTRACTOR_REQUEST";
export const SETUP_EDIT_CONTRACTOR_SUCCESS = "SETUP_EDIT_CONTRACTOR_SUCCESS";
export const SETUP_EDIT_CONTRACTOR_FAILURE = "SETUP_EDIT_CONTRACTOR_FAILURE";

// reset addContractor
// export const RESET_ADD_CONTRACTOR = "RESET_ADD_CONTRACTOR";

// Clear addContractor
export const CLEAR_ADD_CONTRACTOR = "CLEAR_ADD_CONTRACTOR";

// upload required documents
export const UPLOAD_REQUIRED_DOCUMENTS_REQUEST =
  "UPLOAD_REQUIRED_DOCUMENTS_REQUEST";
export const UPLOAD_REQUIRED_DOCUMENTS_SUCCESS =
  "UPLOAD_REQUIRED_DOCUMENTS_SUCCESS";
export const UPLOAD_REQUIRED_DOCUMENTS_FAILURE =
  "UPLOAD_REQUIRED_DOCUMENTS_FAILURE";

// toggle onboarding status
export const TOGGLE_ONBOARDING_STATUS_REQUEST =
  "TOGGLE_ONBOARDING_STATUS_REQUEST";
export const TOGGLE_ONBOARDING_STATUS_SUCCESS =
  "TOGGLE_ONBOARDING_STATUS_SUCCESS";
export const TOGGLE_ONBOARDING_STATUS_FAILURE =
  "TOGGLE_ONBOARDING_STATUS_FAILURE";

// add po data
export const ADD_PO_DATA_REQUEST = "ADD_PO_DATA_REQUEST";
export const ADD_PO_DATA_SUCCESS = "ADD_PO_DATA_SUCCESS";
export const ADD_PO_DATA_FAILURE = "ADD_PO_DATA_FAILURE";

// update po view status
export const UPDATE_PO_VIEW_STATUS_REQUEST = "UPDATE_PO_VIEW_STATUS_REQUEST";
export const UPDATE_PO_VIEW_STATUS_SUCCESS = "UPDATE_PO_VIEW_STATUS_SUCCESS";
export const UPDATE_PO_VIEW_STATUS_FAILURE = "UPDATE_PO_VIEW_STATUS_FAILURE";
export const UPDATE_LOCAL_PO_STATUS_OF_POSITIONS =
  "UPDATE_LOCAL_PO_STATUS_OF_POSITIONS";

// update po payment schedule status
export const UPDATE_PO_PAYMENT_STATUS_REQUEST =
  "UPDATE_PO_PAYMENT_STATUS_REQUEST";
export const UPDATE_PO_PAYMENT_STATUS_SUCCESS =
  "UPDATE_PO_PAYMENT_STATUS_SUCCESS";
export const UPDATE_PO_PAYMENT_STATUS_FAILURE =
  "UPDATE_PO_PAYMENT_STATUS_FAILURE";

// resend signup sms link
export const RESEND_SIGNUP_SMS_LINK_REQUEST = "RESEND_SIGNUP_SMS_LINK_REQUEST";
export const RESEND_SIGNUP_SMS_LINK_SUCCESS = "RESEND_SIGNUP_SMS_LINK_SUCCESS";
export const RESEND_SIGNUP_SMS_LINK_FAILURE = "RESEND_SIGNUP_SMS_LINK_FAILURE";

// get po history list
export const GET_PO_HISTORY_REQUEST = "GET_PO_HISTORY_REQUEST";
export const GET_PO_HISTORY_SUCCESS = "GET_PO_HISTORY_SUCCESS";
export const GET_PO_HISTORY_FAILURE = "GET_PO_HISTORY_FAILURE";

// adp contractor toggle
export const TOGGLE_ADP_STATUS_REQUEST = "TOGGLE_ADP_STATUS_REQUEST";
export const TOGGLE_ADP_STATUS_SUCCESS = "TOGGLE_ADP_STATUS_SUCCESS";
export const TOGGLE_ADP_STATUS_FAILURE = "TOGGLE_ADP_STATUS_FAILURE";

// bulk edit contractor
export const BULK_EDIT_CONTRACTOR_REQUEST = "BULK_EDIT_CONTRACTOR_REQUEST";
export const BULK_EDIT_CONTRACTOR_SUCCESS = "BULK_EDIT_CONTRACTOR_SUCCESS";
export const BULK_EDIT_CONTRACTOR_FAILURE = "BULK_EDIT_CONTRACTOR_FAILURE";

// bulk update po status
export const BULK_UPDATE_PO_STATUS_REQUEST = "BULK_UPDATE_PO_STATUS_REQUEST";
export const BULK_UPDATE_PO_STATUS_SUCCESS = "BULK_UPDATE_PO_STATUS_SUCCESS";
export const BULK_UPDATE_PO_STATUS_FAILURE = "BULK_UPDATE_PO_STATUS_FAILURE";

// bulk update po statue and contractor
export const BULK_UPDATE_CONTRACTOR_AND_PO_STATUS_REQUEST =
  "BULK_UPDATE_CONTRACTOR_AND_PO_STATUS_REQUEST";
export const BULK_UPDATE_CONTRACTOR_AND_PO_STATUS_SUCCESS =
  "BULK_UPDATE_CONTRACTOR_AND_PO_STATUS_SUCCESS";
export const BULK_UPDATE_CONTRACTOR_AND_PO_STATUS_FAILURE =
  "BULK_UPDATE_CONTRACTOR_AND_PO_STATUS_FAILURE";

// reset contractor password
export const RESET_CONTRACTOR_PASSWORD_REQUEST =
  "RESET_CONTRACTOR_PASSWORD_REQUEST";
export const RESET_CONTRACTOR_PASSWORD_SUCCESS =
  "RESET_CONTRACTOR_PASSWORD_SUCCESS";
export const RESET_CONTRACTOR_PASSWORD_FAILURE =
  "RESET_CONTRACTOR_PASSWORD_FAILURE";